import React from 'react';
import { motion } from 'framer-motion';
import { Button, WHATSAPP_URL } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-24 pb-12 overflow-hidden bg-noise" data-id="element-108">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-2/3 h-full bg-nude-dark/30 rounded-bl-[200px] -z-10" data-id="element-109"></div>
      <div className="absolute -top-40 -left-40 w-96 h-96 bg-rosegold/10 rounded-full blur-3xl -z-10" data-id="element-110"></div>

      <div className="container mx-auto px-6 md:px-12" data-id="element-111">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-112">
          {/* Text Content */}
          <div className="lg:col-span-5 lg:col-start-1 z-10 pt-10 lg:pt-0" data-id="element-113">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-114">
              <span className="inline-block py-1 px-3 rounded-full border border-rosegold/30 text-rosegold text-xs font-sans tracking-widest uppercase mb-6" data-id="element-115">
                Medicina Estética Avanzada
              </span>
              <h1 className="text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.1] font-serif text-deepblack mb-6 text-balance" data-id="element-116">
                Sentite{' '}
                <span className="italic font-light text-rosegold" data-id="element-117">bien.</span>
                <br data-id="element-118" />
                Verte <span className="italic font-light" data-id="element-119">mejor.</span>
              </h1>
              <p className="text-lg md:text-xl text-deepblack/70 font-sans font-light mb-10 max-w-md leading-relaxed" data-id="element-120">
                Donde tu belleza se transforma en arte. Descubrí tratamientos de
                alta gama diseñados para resaltar tu mejor versión, en un
                espacio pensado para tu bienestar.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-121">
                <Button href={WHATSAPP_URL} size="lg" data-id="element-122">
                  Agenda tu turno
                </Button>
                <Button href="#servicios" variant="ghost" size="lg" data-id="element-123">
                  Descubrir tratamientos
                </Button>
              </div>
            </motion.div>
          </div>

          {/* Image Composition */}
          <div className="lg:col-span-7 relative mt-12 lg:mt-0" data-id="element-124">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95,
            x: 20
          }} animate={{
            opacity: 1,
            scale: 1,
            x: 0
          }} transition={{
            duration: 1,
            delay: 0.4,
            ease: 'easeOut'
          }} className="relative z-10" data-id="element-125">
              {/* Main Image */}
              <div className="relative aspect-[3/4] md:aspect-[4/5] w-full max-w-lg ml-auto editorial-mask overflow-hidden shadow-2xl" data-id="element-126">
                <img src="https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?q=80&w=2070&auto=format&fit=crop" alt="Mujer relajada en tratamiento de spa" className="object-cover w-full h-full hover:scale-105 transition-transform duration-1000" data-id="element-127" />
                <div className="absolute inset-0 bg-gradient-to-t from-deepblack/40 to-transparent" data-id="element-128"></div>
              </div>

              {/* Floating Element */}
              <motion.div className="absolute -bottom-10 -left-10 md:bottom-10 md:-left-20 bg-softwhite p-6 rounded-2xl shadow-xl max-w-xs border border-nude-dark animate-float" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.8
            }} data-id="element-129">
                <div className="flex items-center gap-4 mb-3" data-id="element-130">
                  <div className="w-12 h-12 rounded-full bg-rosegold/20 flex items-center justify-center text-rosegold" data-id="element-131">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-132">
                      <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" data-id="element-133" />
                    </svg>
                  </div>
                  <div data-id="element-134">
                    <p className="font-serif font-semibold text-deepblack" data-id="element-135">
                      Innovación
                    </p>
                    <p className="text-xs font-sans text-mauve uppercase tracking-wider" data-id="element-136">
                      Tecnología de punta
                    </p>
                  </div>
                </div>
                <p className="text-sm font-sans text-deepblack/70 italic" data-id="element-137">
                  "Un enfoque integral que combina ciencia y estética."
                </p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}